import { useContext, useEffect } from 'react';
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import LabelComponent from 'components/design-system/Label/Label';
import Text from 'components/design-system/Text/Text';
import InputComponent from 'components/design-system/input/Input';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { es } from 'date-fns/locale';
import { MatchContext } from '../../context/MatchContext';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePickerComponent } from 'components/design-system/DatePicker/DatePicker';
import { PERMISOS } from 'const/Permisos';
import { VerificarPermisos } from 'components/VerificarPermisos/VerificarPermisos';
import { AuthContext } from 'context';
import { Search } from '@mui/icons-material';
import ButtonComponent from 'components/design-system/Button/Button';
import { Hidden } from '@mui/material';

export const PreviaMatchCampos = ({
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  isSubmitting
}) => {
  const { isTienePermisos, isTieneSucursales } = useContext(AuthContext);
  const {
    getTipodeResiduos,
    listaTipoResiduos,
    listaTipoRecursos,
    getEmpresas,
    getSucursal,
    isCargandoListaEmpresas,
    isCargandoListaSucursales,
    isCargandoResiduosRecursos,
    listaEmpresas,
    listaSucursales,
    handleCargarResiduosYRecursos,
    handleCargarRecursos,
    handleReCargarRecursos
  } = useContext(MatchContext);

  const tieneNegocio = isTieneSucursales() || null;

  useEffect(() => {
    if (isTienePermisos(PERMISOS.matchFiltroResiduo)) {
      getTipodeResiduos();
    }

    if (isTienePermisos(PERMISOS.matchFiltroNegocio)) {
      getEmpresas();
    }
  }, []);

  useEffect(() => {
    setFieldValue('sucursales', listaSucursales);
  }, [setFieldValue, listaSucursales]);

  useEffect(() => {
    if (values.empresa) {
      getSucursal(values.empresa.codigoEmpresa);
    }
  }, [values.empresa]);

  useEffect(() => {
    //Se debe enviar un null para cuando es un usuario sin negocio.
    //Si el usuario tiene negocio o puede selccionar una sucursal se envía el codigoSucursal
    handleCargarResiduosYRecursos(
      values.sucursal && values.sucursal.codigoSucursal
        ? values.sucursal.codigoSucursal
        : null
    );
  }, [values.sucursal]);

  useEffect(() => {
    if (values.codigosTipoResiduo) {
      handleCargarRecursos(values.codigosTipoResiduo.codigoTipoResiduo);
    }
  }, [values.codigosTipoResiduo]);

  return (
    <>
      <VerificarPermisos nombrePermiso={PERMISOS.matchFiltroNegocio}>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <AutocompleteComponent
            name="empresa"
            options={listaEmpresas || []}
            disabled={isCargandoListaEmpresas || isSubmitting}
            isLoading={isCargandoListaEmpresas}
            value={values.empresa}
            getOptionLabel={option => (option ? option.nombreEmpresa : '')}
            clearOnEscape={true}
            openOnFocus={true}
            accesor={'nombreEmpresa'}
            noOptionsText="Sin opciones"
            onBlur={() => setFieldTouched('empresa')}
            onChange={(ev, empresa, reason) => {
              let data = {
                target: { name: 'empresa', value: empresa }
              };

              if (reason === 'clear') {
                data.target.value = '';
              }

              setFieldValue('codigosTipoResiduo', null);
              setFieldValue('codigosRecurso', null);
              setFieldValue('sucursal', null);
              setFieldValue('sucursales', []);
              handleChange(data);
            }}
          >
            <InputComponent
              className="h-9"
              estado={
                errors.empresa
                  ? { tipo: 'error', mensaje: errors.empresa }
                  : null
              }
              fullWidth
              label={<LabelComponent>NEGOCIO</LabelComponent>}
              touched={touched.empresa ? true : false}
            />
          </AutocompleteComponent>
        </div>
      </VerificarPermisos>

      <VerificarPermisos nombrePermiso={PERMISOS.matchFiltroSucursal}>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <AutocompleteComponent
            name="sucursal"
            disabled={isCargandoListaSucursales || isSubmitting}
            isLoading={isCargandoListaSucursales}
            options={values.sucursales || []}
            value={values.sucursal}
            getOptionLabel={option => (option ? option.nombreSucursal : '')}
            clearOnEscape={true}
            openOnFocus={true}
            accesor={'nombreSucursal'}
            noOptionsText="Sin opciones"
            onBlur={() => setFieldTouched('sucursal')}
            onChange={(ev, sucursal, reason) => {
              let data = {
                target: { name: 'sucursal', value: sucursal }
              };
              if (reason === 'clear') {
                data.target.value = '';
              }
              setFieldValue('codigosTipoResiduo', null);
              setFieldValue('codigosRecurso', null);
              handleChange(data);
            }}
          >
            <InputComponent
              className="h-9"
              estado={
                errors.sucursal
                  ? { tipo: 'error', mensaje: errors.sucursal }
                  : null
              }
              fullWidth
              label={<LabelComponent>SUCURSAL</LabelComponent>}
              touched={touched.sucursal ? true : false}
            />
          </AutocompleteComponent>
        </div>
      </VerificarPermisos>

      <VerificarPermisos nombrePermiso={PERMISOS.matchFiltroResiduo}>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <AutocompleteComponent
            name="codigosTipoResiduo"
            disabled={isCargandoResiduosRecursos || isSubmitting}
            isLoading={isCargandoResiduosRecursos}
            options={listaTipoResiduos || []}
            value={values.codigosTipoResiduo}
            getOptionLabel={option => (option ? option.nombreTipo : '')}
            clearOnEscape={true}
            openOnFocus={true}
            accesor={'nombreTipo'}
            noOptionsText="Sin opciones"
            onBlur={() => setFieldTouched('codigosTipoResiduo')}
            onChange={(ev, tipoResiduo, reason) => {
              let data = {
                target: { name: 'codigosTipoResiduo', value: tipoResiduo }
              };
              if (reason === 'clear') {
                data.target.value = '';
                setFieldValue('codigosRecurso', null);
                handleReCargarRecursos();
              }
              handleChange(data);
            }}
          >
            <InputComponent
              className="h-9"
              estado={
                errors.codigosTipoResiduo
                  ? { tipo: 'error', mensaje: errors.codigosTipoResiduo }
                  : null
              }
              fullWidth
              label={<LabelComponent>RESIDUOS</LabelComponent>}
              touched={touched.codigosTipoResiduo ? true : false}
            />
          </AutocompleteComponent>
        </div>
      </VerificarPermisos>

      <VerificarPermisos nombrePermiso={PERMISOS.matchFiltroRecursos}>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <AutocompleteComponent
            name="codigosRecurso"
            disabled={isCargandoResiduosRecursos || isSubmitting}
            isLoading={isCargandoResiduosRecursos}
            accesor="nombreRecurso"
            options={listaTipoRecursos || []}
            value={values.codigosRecurso}
            getOptionLabel={option => (option ? option.nombreRecurso : '')}
            clearOnEscape={true}
            openOnFocus={true}
            noOptionsText="Sin opciones"
            onBlur={() => setFieldTouched('codigosRecurso')}
            touched={touched.codigosRecurso ? true : false}
            onChange={(ev, tipoRecurso, reason) => {
              let data = {
                target: { name: 'codigosRecurso', value: tipoRecurso }
              };

              if (reason === 'clear') {
                data.target.value = '';
              }
              handleChange(data);
            }}
          >
            <InputComponent
              className="h-9"
              fullWidth
              label={<LabelComponent>RECURSOS</LabelComponent>}
              touched={touched.codigosRecurso ? true : false}
              estado={
                errors.codigosRecurso
                  ? { tipo: 'error', mensaje: errors.codigosRecurso }
                  : null
              }
            />
          </AutocompleteComponent>
        </div>
      </VerificarPermisos>

      <VerificarPermisos nombrePermiso={PERMISOS.matchFiltroFechas}>
        <div
          className={`
        col-span-12 sm:col-span-6 
          ${
            isTienePermisos(PERMISOS.matchFiltroNegocio) ||
            isTienePermisos(PERMISOS.matchFiltroSucursal)
              ? 'lg:col-span-6'
              : 'lg:col-span-4'
          }  
        `}
        >
          <div className="grid grid-cols-12 gap-x-5">
            <div className="col-span-12 sm:col-span-6 lg:col-span-6">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DesktopDatePicker
                  fullWidth
                  disabled={
                    isSubmitting ||
                    (!tieneNegocio && !isTienePermisos(PERMISOS.editarSucursal))
                  }
                  label={<LabelComponent>FECHA INICIAL</LabelComponent>}
                  name="fechaDisponibilidadInicio"
                  inputFormat="dd/MM/yyyy"
                  value={values.fechaDisponibilidadInicio}
                  defaultValue={values.fechaDisponibilidadInicio}
                  maxDate={values.fechaDisponibilidadFin}
                  onChange={value => {
                    handleChange({
                      target: {
                        name: 'fechaDisponibilidadInicio',
                        value: value
                      }
                    });
                  }}
                  slots={{ textField: DatePickerComponent }}
                />
              </LocalizationProvider>
            </div>
            <div className="col-span-12 sm:col-span-6 lg:col-span-6">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DesktopDatePicker
                  fullWidth
                  disabled={
                    isSubmitting ||
                    (!tieneNegocio && !isTienePermisos(PERMISOS.editarSucursal))
                  }
                  label={<LabelComponent>FECHA TÉRMINO</LabelComponent>}
                  name="fechaDisponibilidadFin"
                  inputFormat="dd/MM/yyyy"
                  value={values.fechaDisponibilidadFin}
                  defaultValue={values.fechaDisponibilidadFin}
                  onChange={value => {
                    handleChange({
                      target: {
                        name: 'fechaDisponibilidadFin',
                        value: value
                      }
                    });
                  }}
                  minDate={values.fechaDisponibilidadInicio}
                  slots={{ textField: DatePickerComponent }}
                />
              </LocalizationProvider>
            </div>
            {!tieneNegocio && !isTienePermisos(PERMISOS.editarSucursal) && (
              <div className="col-span-12 lg:col-span-12">
                <div className="bg-warning-light rounded px-4 py-2 mt-2">
                  <Text size="S">
                    Opciones de búsqueda adicionales para usuarios que hayan{' '}
                    <b className="text-black">registrado su negocio</b>
                  </Text>
                </div>
              </div>
            )}
          </div>
        </div>
      </VerificarPermisos>

      <div
        className={`
          col-span-12 sm:pt-7 mb-4 sm:mb-0
          ${
            isTienePermisos(PERMISOS.matchFiltroNegocio) ||
            isTienePermisos(PERMISOS.matchFiltroSucursal)
              ? 'sm:col-span-3'
              : 'sm:col-span-2'
          }  
      `}
      >
        <ButtonComponent
          form="previaMatch"
          fullWidth
          className="justify-center h-auto"
          buttonType="submit"
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Hidden lgUp>
                <Search className="ml-2" />
              </Hidden>
              <Hidden lgDown>
                Buscando... <Search className="ml-2" />
              </Hidden>
            </>
          ) : (
            <>
              <Hidden lgUp>
                <Search className="ml-2" />
              </Hidden>
              <Hidden lgDown>
                Buscar Match <Search className="ml-2" />
              </Hidden>
            </>
          )}
        </ButtonComponent>
      </div>
    </>
  );
};
